import React, { useMemo } from 'react';

import { INVOICE_COLUMN_CLASSNAME_MAP } from '../documentHub.const';

interface InvoiceLoaderRowProps {
    index?: number;
    headCells?: any[];
}

const InvoiceLoaderRow: React.FC<InvoiceLoaderRowProps> = ({ headCells }) => {
    const tableCells = useMemo(
        () => [
            {
                key: 'invoiceNumber',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.invoiceNumber}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'orderId',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.orderId}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'status',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.status}>
                        <div className="items-center flex">
                            <div className="custom-loading flex rounded-md">Lorem Ipsum</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'dueDate',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.dueDate}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'dateInvoiced',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.dateInvoiced}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'lastUpdated',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.lastUpdated}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'totalPrice',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.totalPrice}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'paymentTerms',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.paymentTerms}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'daysPending',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.daysPending}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'pod',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.pod}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ips</div>
                        </div>
                    </td>
                ),
            },
            {
                key: 'podUploadedAt',
                htmlDynamic: (
                    <td className={INVOICE_COLUMN_CLASSNAME_MAP.podUploadedAt}>
                        <div className="items-center flex">
                            <div className="custom-loading flex">Lorem Ipsum Lorem</div>
                        </div>
                    </td>
                ),
            },
        ],
        []
    );

    if (!headCells) {
        return (
            <>
                {tableCells.map((cell) => (
                    <React.Fragment key={cell.key}>{cell.htmlDynamic}</React.Fragment>
                ))}
            </>
        );
    }

    return (
        <>
            {headCells
                .filter((cell: any) => cell.visible)
                .map((cell: any) => {
                    if (cell.id === 'checkbox') {
                        return (
                            <React.Fragment key="checkbox">
                                <td className="w-[40px] min-w-[40px] max-w-[40px] sticky left-0 bg-inherit z-[1] table-cell-with-tooltip">
                                    <div className="table-col-tooltip-space-common-xs flex items-center h-full">
                                        <span className="custom-loading block w-4 h-4 rounded" />
                                    </div>
                                </td>
                            </React.Fragment>
                        );
                    }

                    const matched = tableCells.find((tCell) => tCell.key === cell.id);
                    if (!matched) return null;

                    return <React.Fragment key={cell.id}>{matched.htmlDynamic}</React.Fragment>;
                })}
        </>
    );
};

export default InvoiceLoaderRow;
